import React, { Component } from 'react';

import { Button } from './components/Button/index';
import { ScoreSummary } from './components/ScoreSummary/index';
import { Recommendation } from './components/Recommendation/index';
import { getAssessmentResults, getAssessment, getAssessmentReportFile } from '../../services/index';

import { Trans, i18nMark, withI18n } from 'lingui-react';

import ReactLoading from 'react-loading';
import qs from 'querystringify';

import downloadPdfIcon from '../../assets/images/pdf-icon.svg';

import './assessmentReport.css';

class AssessmentReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      releaseVersion: document.getElementById('releaseVersion').innerHTML,
      radarChartDataOrganization: {
        labels: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
        datasets: [
          {
            label: props.i18n._(i18nMark('Benchmark')),
            borderColor: 'rgb(255,134,77)',
            backgroundColor: 'rgba(255,134,77,.1)',
            pointBackgroundColor: 'rgb(255,134,77)',
            pointBorderColor: '#fff',
            pointBorderWidth: 1,
            data: [0, 0, 0, 0, 0, 0, 0]
          },
          {
            label: props.i18n._(i18nMark('Organization')),
            borderColor: 'rgb(69,46,191)',
            backgroundColor: 'rgba(69,46,191,.1)',
            pointBackgroundColor: 'rgb(69,46,191)',
            pointBorderColor: '#fff',
            pointBorderWidth: 1,
            data: [0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      radarChartDataTechnology: {
        labels: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
        datasets: [
          {
            label: props.i18n._(i18nMark('Benchmark')),
            borderColor: 'rgb(255,134,77)',
            backgroundColor: 'rgba(255,134,77,.1)',
            pointBackgroundColor: 'rgb(255,134,77)',
            pointBorderColor: '#fff',
            pointBorderWidth: 1,
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
          {
            label: props.i18n._(i18nMark('Technology')),
            borderColor: 'rgb(69,46,191)',
            backgroundColor: 'rgba(69,46,191,.1)',
            pointBackgroundColor: 'rgb(69,46,191)',
            pointBorderColor: '#fff',
            pointBorderWidth: 1,
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      chartDataLine: {
        labels: [props.i18n._(i18nMark('ORGANIZATION')), props.i18n._(i18nMark('TECHNOLOGY'))],
        datasets: [
          {
            label: [props.i18n._(i18nMark('ORGANIZATION'))],
            backgroundColor: 'rgba(69,46,191,0.3)',
            data: [0, 0],
            datalabels: {
              display: true,
              color: [
                '#3413B1',
                '#3413B1'
              ],
              font: {
                family: 'Gilroy-Bold',
                size: '16'
              },
              anchor: 'end',
              padding: {
                bottom: 8
              }
            }
          },
          {
            label: [props.i18n._(i18nMark('TECHNOLOGY'))],
            backgroundColor: 'rgba(255,134,77,0.3)',
            data: [0, 0],
            datalabels: {
              display: true,
              color: [
                '#FD713C',
                '#FD713C'
              ],
              font: {
                family: 'Gilroy-Bold',
                size: '16'
              },
              anchor: 'end',
              padding: {
                bottom: 8
              }
            }
          }
        ]
      },
      dateTime: this.getGeneratedDate(),
      assessmentResult: {
        company: {},
        organization: {},
        technology: {},
        recommendations: []
      }
    };
  }

  componentDidMount() {
    document.title = this.props.i18n._(i18nMark('Security Selfie'));
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    this.setState({ loading: true });
    const development = qs.parse(this.props.location.search).development;
    getAssessment(assessmentId).then(assessment => {
      if (!assessment.completed && !development) {
        this.props.history.push('/dashboard');
      } else {
        getAssessmentResults(assessmentId, this.state.dateTime).then(result => {
          this.setState({ assessmentResult: result, loading: false }, () => {
            let chartDataLine = this.state.chartDataLine;
            chartDataLine.datasets[0].data = [
              this.state.assessmentResult.organization.score,
              this.state.assessmentResult.technology.score
            ];
            chartDataLine.datasets[1].data = [
              Number.parseFloat(
                this.state.assessmentResult.organization.benchmarkScore
              ),
              Number.parseFloat(this.state.assessmentResult.technology.benchmarkScore)
            ];

            let scoreRadar = this.state.radarChartDataOrganization;
            scoreRadar.datasets[1].data = [];
            this.state.assessmentResult.organization.topics.map(element =>
              scoreRadar.datasets[1].data.push(Number.parseFloat(element.score))
            );
            scoreRadar.datasets[0].data = [];
            this.state.assessmentResult.organization.topics.map(element =>
              scoreRadar.datasets[0].data.push(Number.parseFloat(element.benchmarkScore))
            );

            this.setState({
              radarChartDataOrganization: scoreRadar
            });

            scoreRadar = this.state.radarChartDataTechnology;
            scoreRadar.datasets[1].data = [];
            this.state.assessmentResult.technology.topics.map(element =>
              scoreRadar.datasets[1].data.push(Number.parseFloat(element.score))
            );
            scoreRadar.datasets[0].data = [];
            this.state.assessmentResult.technology.topics.map(element =>
              scoreRadar.datasets[0].data.push(Number.parseFloat(element.benchmarkScore))
            );
            this.setState({
              radarChartDataTechnology: scoreRadar
            })

            this.setState({
              chartDataLine: chartDataLine
            });
          });
        });
      }
    })
  }

  exportPdf() {
    const reportFileId = this.state.assessmentResult.reportFileId;
    if (reportFileId) {
      var link = document.createElement('a');
      link.href = getAssessmentReportFile(this.state.assessmentResult.reportFileId);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  getGeneratedDate = () => {
    const now = new Date();
    return now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2) + ' ' + ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2) + ':' + ('0' + now.getSeconds()).slice(-2);
  }
  render() {
    return (
      <div>
        <div key={1} className="assessment-container">
          <div className="container">
            <div className="row title-assessment-header">
              <div className="col-12 col-lg-9">
                <h3><Trans id="Assessment Report" /></h3>
                <p className="gray-content">
                  <span> <Trans id="Generated on" /> {this.state.dateTime + ', Security Selfie ® Version ' + this.state.releaseVersion}
                  </span>
                </p>
                <p className="gray-content">
                  <Trans id="The assessment is completed and the results are shown below." />
                  <br />
                  <Trans id="The assessment report is available for download as a PDF." />
                </p>
              </div>
              <div className="col-12 col-lg-3 d-flex flex-column justify-content-sm-center align-items-lg-end">
                <Button
                  styleButton="download-button"
                  icon={true}
                  text={this.props.i18n._(i18nMark('Download report as PDF'))}
                  srcImage={downloadPdfIcon}
                  onClick={() => this.exportPdf()}
                />
              </div>
            </div>
            <h3 className="header-title-component"><Trans id="Rating" /></h3>
            <ScoreSummary
              assessmentResult={this.state.assessmentResult}
              chartDataLine={this.state.chartDataLine}
              chartDataOrganization={this.state.radarChartDataOrganization}
              chartDataTechnology={this.state.radarChartDataTechnology}
            />
            <hr />
            <Recommendation recommendations={this.state.assessmentResult.recommendations} />
          </div>
        </div>
        <div className={this.state.loading ? 'loading-overlay active' : 'loading-overlay'}>
          <ReactLoading type="spin" color="#444" className="loading-icon" />
        </div>
      </div>
    );
  }
}

export default withI18n()(AssessmentReport)


// WEBPACK FOOTER //
// ./src/screens/AssessmentReport/AssessmentReport.js